import { useEffect, useState } from "react";

/**
 * Trailing-edge debounce.
 *
 * Used to key the symbol-search query so a request goes out per *pause*, not
 * per keystroke. 200ms is the balance point: below it you're issuing a request
 * per character; above it the list visibly lags behind the caret.
 */
export function useDebouncedValue<T>(value: T, delayMs = 200): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
